import { MitantragstellerDataDisplayModel, MitantragstellerDisplayModel } from "@/api/model-index";
import { MitantragstellerService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GetMitantragstellerDataResolver  {
    constructor(protected mitantragstellerService: MitantragstellerService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<MitantragstellerDataDisplayModel> {
        let id: string = <string>route.params['id'];
        let antragstellerId: string = <string>route.params['abschnittid'];

        await this.unfinishedHttpMethodsService.waitByUrl(state.url);

        return this.mitantragstellerService.apiMitantragstellerGetMitantragstellerDataAnfrageIdIdGet({ id: antragstellerId, anfrageId: id }).pipe(map(response => {
            return response;
        })).toPromise();;
    }
}